// react-native-config web shim. @config/index.js does `import Config from
// "react-native-config"` then re-exports baseURL/appEnv/androidAppStore/etc.
// Real native reads these from .env.staging at build time; on web we return a
// staging-ish object and "" for anything unset so @config never throws.
// devserver.js injects window.__CM_ENV ("staging" | "prod" | "preprod") before the bundle.
const CM_ENV = (typeof window !== "undefined" && window.__CM_ENV) || "staging";
// devserver.js reads ANDROID_VERSION_CODE straight out of the real .env.<ENV> file (the
// same one native builds use) and injects it here, so the harness always reports whatever
// build number is actually current — no separate hardcoded number to bump on release.
// The "3146041" default is only used if the injection is missing (e.g. a static build
// served without devserver.js).
const ANDROID_VERSION_CODE =
  (typeof window !== "undefined" && window.__CM_ANDROID_VERSION_CODE) ||
  "3146041";
const values = {
  // preprod is prod-side (prod DB; .env.preprod APP_ENV=production).
  APP_ENV: CM_ENV === "prod" || CM_ENV === "preprod" ? "production" : "staging",
  ANDROID_APP_STORE: "playstore",
  // Force-update gate: @config exports APP_VERSION = Config.VERSION_CODE, compared
  // client-side in UpdateAppModal against the remote min-version (versionId, from
  // /leader/setup-4). Reusing the real ANDROID_VERSION_CODE means it can't drift behind
  // the remote minimum the way a one-time hardcoded snapshot did.
  VERSION_CODE: ANDROID_VERSION_CODE,
  ANDROID_VERSION_CODE,
  ANDROID_VERSION_NAME:
    (typeof window !== "undefined" && window.__CM_ANDROID_VERSION_NAME) ||
    "9.9.9",
  // Point at SAME-ORIGIN proxy paths. The webpack dev-server forwards these to
  // the real staging hosts server-side, so the browser sees no CORS. See
  // devServer.proxy in webpack.web.config.js. (.env.staging real targets:
  //   BASE_URL       https://staging-dev.citymall.dev/api/
  //   SEARCH_URL     https://search-cf.citymall.live/search/api/
  //   STATIC_PAGE    https://citymall.dev/
  //   APPLINKS       https://w.staging-dev.citymall.dev/api/ )
  BASE_URL: "/api/",
  SEARCH_URL: "/search-api/",
  STATIC_PAGE_URL: "/static-page/",
  APPLINKS_BASE_URL: "/applinks-api/",
  // websocket is non-critical for first-screen; left pointing at staging (will
  // fail handshake under CORS, harmless).
  SOCKET_URL:
    CM_ENV === "prod" || CM_ENV === "preprod"
      ? "wss://citymall.live/partner-ws" // .env.production / .env.preprod
      : "wss://staging-dev.citymall.dev/partner-ws",
};
const Config = new Proxy(values, {
  get(t, k) {
    if (k === "__esModule") return undefined;
    return k in t ? t[k] : "";
  },
});
module.exports = { __esModule: true, default: Config };
